// A relative in-app path: one leading slash, then no whitespace and no
// backslash anywhere (browsers treat `/\host` as `//host`).
export const isRelativeNotificationLink = (link: string): boolean =>
  /^\/(?![\\/])[^\\\s]*$/.test(link);

// Mirrors `isExternalNotificationLink` in ora-be's notificationHelpers: an
// absolute http(s) URL with a host. Anything else that passes validation is a
// relative in-app path.
export const isExternalNotificationLink = (link: string): boolean => {
  // No whitespace, backslashes, or control characters (a NUL would otherwise
  // pass validation and fail at the database).
  // eslint-disable-next-line no-control-regex -- the control range is the point
  if (!/^https?:\/\/[^\s\\\x00-\x1f\x7f]+$/i.test(link)) return false;
  try {
    const url = new URL(link);
    // `https://oraai.com@evil.example` reads as an oraai.com link.
    return url.hostname.length > 0 && !url.username && !url.password;
  } catch {
    return false;
  }
};
